<div class="billing-control-create-round-modal">
  <p class="billing-control-create-round-modal__hint">
    Informe a data de agendamento ou use execução manual.
  </p>

  <div class="billing-control-create-round-modal__summary">
    <span
      class="billing-control-create-round-modal__summary-badge billing-control-create-round-modal__summary-badge--manual"
      *ngIf="!scheduledDate"
    >
      Execução manual
    </span>
    <span
      class="billing-control-create-round-modal__summary-badge billing-control-create-round-modal__summary-badge--scheduled"
      *ngIf="scheduledDate"
    >
      {{ scheduledDate | date: 'dd/MM/yyyy HH:mm' }}
    </span>
    <button
      pButton
      type="button"
      label="Execução manual"
      class="p-button-outlined p-button-secondary p-button-sm"
      (click)="setManualExecution()"
    ></button>
  </div>

  <div class="billing-control-create-round-modal__calendar-panel">
    <p-calendar
      inputId="billingControlRoundSchedule"
      [(ngModel)]="scheduledDate"
      [inline]="true"
      [showTime]="true"
      [minDate]="minDate"
      dateFormat="dd/mm/yy"
      hourFormat="24"
      styleClass="billing-control-create-round-modal__calendar"
    />
  </div>

  <div class="billing-control-create-round-modal__actions">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      label="Criar rodada"
      icon="pi pi-plus"
      (click)="confirm()"
    ></button>
  </div>
</div>
